
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M51.897 16.324a6.065 6.065 0 0 0-1.623-2.721 6.33 6.33 0 0 0-2.803-1.575C43.591 11 27.975 11 27.975 11s-15.617.031-19.497 1.059a6.33 6.33 0 0 0-2.802 1.575 6.064 6.064 0 0 0-1.623 2.721c-1.174 6.694-1.63 16.894.032 23.32a6.065 6.065 0 0 0 1.623 2.722 6.33 6.33 0 0 0 2.802 1.575C12.39 45 28.007 45 28.007 45s15.616 0 19.496-1.028a6.33 6.33 0 0 0 2.803-1.575 6.065 6.065 0 0 0 1.623-2.721c1.237-6.704 1.619-16.897-.032-23.352z","fill":"red"}}),_c('path',{attrs:{"d":"M23.316 35.233 36.101 28l-12.785-7.232v14.465z","fill":"#fff"}})])
          )
        }
      }
    